<div class="container">
  <svg [icon]="icon" class="svg48-40"/>
  <div class="card-body">
    <div class="title">
      <h2>{{ title | translate }}</h2>
    </div>
    <div class="body-1">
      {{ text | translate }}
    </div>
    <div class="footer">
      <button (click)="redirect() " class="button-padding btn-secondary">
        {{ buttonName | translate }}
      </button>
      <div *ngIf="mobileText" class="mobile-text caption-2">
        {{ mobileText | translate }}
      </div>
    </div>

  </div>
</div>
